export default function convertAgeGroup(ageGroup) {
    switch(ageGroup) {
        case '5': return "SUB 5";
        case '6': return "SUB 6";
        case '7': return "SUB 7";
        case '8': return "SUB 8";
        case '9': return "SUB 9";
        case '10': return "SUB 10";
        case '11': return "SUB 11";
        case '12': return "SUB 12";
        case '13': return "SUB 13";
        case '14': return "SUB 14";
        case '15': return "SUB 15";
        case '16': return "SUB 16";
        case '17': return "SUB 17";
        case '18': return "SUB 18";
        case "SUB 5": return "até 5 anos";
        case "SUB 6": return "até 6 anos";
        case "SUB 7": return "até 7 anos";
        case "SUB 8": return "até 8 anos";
        case "SUB 9": return "até 9 anos";
        case "SUB 10": return "até 10 anos";
        case "SUB 11": return "até 11 anos";
        case "SUB 12": return "até 12 anos";
        case "SUB 13": return "até 13 anos";
        case "SUB 14": return "até 14 anos";
        case "SUB 15": return "até 15 anos";
        case "SUB 16": return "até 16 anos";
        case "SUB 17": return "até 17 anos";
        case "SUB 18": return "até 18 anos";
        default: return '...'
    }
}